<div class="experience-poll">
  <h2 class="experience-poll__title">
    {{ 'experiencePoll.title' | translate }}
  </h2>

  <div class="experience-poll__options">
    <button
      *ngFor="let option of options"
      class="experience-poll__option"
      [class.experience-poll__option--selected]="selectedRating === option.value"
      (click)="onSelect(option.value)"
      [attr.aria-label]="option.labelKey | translate"
    >
      <span class="experience-poll__emoji">{{ option.emoji }}</span>
      <span class="experience-poll__label">{{ option.labelKey | translate }}</span>
    </button>
  </div>
</div>
